import React from 'react';
import { useLocation } from 'react-router-dom';
import { Page } from '../Common/Components/Page';
import { SettingsLayout } from './Components/Settings/SettingsLayout';

export const Settings = (): React.JSX.Element => {
  // Admin sections are list views — they need the page-header search bar
  // and pagination. Personal sections (Profile/Security/etc.) don't.
  // Deciding here means Page's `isSearchable` effect lines up with the
  // active route on first paint, avoiding a child-vs-parent useEffect
  // race that hides the header on a fresh load of /me/admin/*.
  const { pathname } = useLocation();
  const isAdminSection = pathname.startsWith('/me/admin/');

  return (
    <Page title="Settings" isSearchable={isAdminSection}>
      <SettingsLayout />
    </Page>
  );
};
